const MICROPHONE_ICON_PATH =
  "M128,176a48.05,48.05,0,0,0,48-48V64a48,48,0,0,0-96,0v64A48.05,48.05,0,0,0,128,176ZM96,64a32,32,0,0,1,64,0v64a32,32,0,0,1-64,0Zm40,143.6V232a8,8,0,0,1-16,0V207.6A80.11,80.11,0,0,1,48,128a8,8,0,0,1,16,0,64,64,0,0,0,128,0,8,8,0,0,1,16,0A80.11,80.11,0,0,1,136,207.6Z"

const RECORDING_FAVICON_COLOR = "#F1C21B"
const PULSE_OPACITY_FRAMES = [1, 0.3]
const PULSE_INTERVAL_MILLISECONDS = 800

const buildFaviconDataUri = (fillOpacity: number): string => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="32" height="32"><path fill="${RECORDING_FAVICON_COLOR}" fill-opacity="${fillOpacity}" d="${MICROPHONE_ICON_PATH}"/></svg>`
  return `data:image/svg+xml,${encodeURIComponent(svg)}`
}

let capturedOriginalFaviconHref: string | null = null
let pulseIntervalId: ReturnType<typeof setInterval> | null = null

const resolveFaviconLink = (): HTMLLinkElement | null => document.querySelector("link[rel*='icon']")

const stopPulse = (): void => {
  if (pulseIntervalId !== null) {
    clearInterval(pulseIntervalId)
    pulseIntervalId = null
  }
}

export const startTranscriptionFavicon = (): void => {
  const faviconLink = resolveFaviconLink()
  if (!faviconLink) {
    return
  }

  stopPulse()

  if (capturedOriginalFaviconHref === null) {
    capturedOriginalFaviconHref = faviconLink.href
  }

  faviconLink.type = "image/svg+xml"

  let pulseFrameIndex = 0
  const applyNextPulseFrame = (): void => {
    const fillOpacity = PULSE_OPACITY_FRAMES[pulseFrameIndex % PULSE_OPACITY_FRAMES.length]
    faviconLink.href = buildFaviconDataUri(fillOpacity)
    pulseFrameIndex += 1
  }

  applyNextPulseFrame()
  pulseIntervalId = setInterval(applyNextPulseFrame, PULSE_INTERVAL_MILLISECONDS)
}

export const stopTranscriptionFavicon = (): void => {
  stopPulse()

  const faviconLink = resolveFaviconLink()
  if (faviconLink && capturedOriginalFaviconHref !== null) {
    faviconLink.href = capturedOriginalFaviconHref
  }
}
